const NARROW_MAX = 768;

export default {
  props: {
    toolsLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      treeDrawerOpen: false,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
    };
  },
  computed: {
    isNarrowToolsViewport() {
      return this.toolsLayout && this.viewportWidth <= NARROW_MAX;
    },
    treePanelCollapsed() {
      if (!this.isNarrowToolsViewport) return false;
      return !this.treeDrawerOpen;
    },
    clientCollapseLeft() {
      if (!this.toolsLayout) return true;
      if (!this.isNarrowToolsViewport) return true;
      return false;
    },
    treePanelWidth() {
      return this.isNarrowToolsViewport ? Math.min(280, this.viewportWidth - 48) : 240;
    },
  },
  mounted() {
    if (this.toolsLayout) {
      this.onViewportResize = () => {
        this.viewportWidth = window.innerWidth;
        if (!this.isNarrowToolsViewport) {
          this.treeDrawerOpen = false;
        }
      };
      window.addEventListener('resize', this.onViewportResize, {passive: true});
    }
  },
  beforeDestroy() {
    if (this.onViewportResize) {
      window.removeEventListener('resize', this.onViewportResize);
    }
  },
  methods: {
    toggleTreeDrawer() {
      this.treeDrawerOpen = !this.treeDrawerOpen;
    },
    closeTreeDrawer() {
      this.treeDrawerOpen = false;
    },
  },
};
